import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { dispatch } from '../store';

const initialState = {
  ToPayOrderList: createOrderListState(),
  ToVerifyOrderList: createOrderListState(),
  ToPackOrderList: createOrderListState(),
  ToDeliveryOrderList: createOrderListState(),
  DeliveryPickedUpOrderList: createOrderListState(),
  AllOrderList: createOrderListState(),
  badge: {},
  isGettingToPayOrderList: false,
  isGettingToVerifyList: false,
  isGettingToPackOrderList: false,
  isGettingToDeliveryOrderList: false,
  isGettingAllOrderList: false,
  isGettingDeliveryPickedUpOrderList: false,
};

// Helper function to create default order list state
function createOrderListState() {
  return {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  };
}

// Slice
export const ordersSlice = createSlice({
  name: 'myOrders',
  initialState,
  reducers: {
    setBadge: (state, action) => {
      state.badge = action.payload;
    },
    setOrderList: (state, action) => {
      const { key, data } = action.payload;
      state[key] = {
        ...data,
        results: [...state[key].results, ...data.results],
      };
    },
    setIsGettingOrderList: (state, action) => {
      const { key, isLoading } = action.payload;
      state[`isGetting${key}`] = isLoading;
    },
    clearOrderList: (state, action) => {
      const { key } = action.payload;
      state[key] = createOrderListState();
    },
  },
});

export const { setBadge, setOrderList, setIsGettingOrderList, clearOrderList } = ordersSlice.actions;

export default ordersSlice.reducer;

// Async action creator
export const handleGettingOrderList = async (key, task, page) => {
  if (page) {
    task = task === 'All' ? '' : task;
    dispatch(setIsGettingOrderList({ key, isLoading: true }));

    try {
      const link = `ecommerce/order/list/?page=${page}&status=${task}&query=&page_size=3&order_by=-created_at`;
      const res = await axios.get(link);

      if (res.status === 200) {
        if (parseInt(page, 10) === 1) {
          dispatch(clearOrderList({ key }));
        }
        dispatch(setOrderList({ key, data: res.data }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsGettingOrderList({ key, isLoading: false }));
    }
  }
};

export const handleGettingOrderBadge = async () => {
  try {
    const link = `ecommerce/order/badge/`;
    const res = await axios.get(link);
    if (res.status === 200) {
      dispatch(setBadge(res.data));
    }
  } catch (err) {
    console.error(err);
  }
};

// Usage examples for different tasks
// export const handleGettingToPayOrderList = (page) =>
//   handleGettingOrderList('ToPayOrderList', 'To Pay', page);

// export const handleGettingToVerifyOrderList = (page) =>
//   handleGettingOrderList('ToVerifyOrderList', 'To Verify', page);

// export const handleGettingToPackOrderList = (page) =>
//   handleGettingOrderList('ToPackOrderList', 'To Pack', page);

// export const handleGettingToDeliveryOrderList = (page) =>
//   handleGettingOrderList('ToDeliveryOrderList', 'To Delivery', page);

// export const handleGettingAllOrderList = (page) =>
//   handleGettingOrderList('AllOrderList', '', page);
